module.exports = __webpack_public_path__ + "img/img10.b4ee5570.png";